<template>
    <v-row no-gutters>
        <v-col class="pe-1">
            <v-autocomplete
                label="Account"
                v-model="line.ledger_account_id"
                :rules="[isRequired]"
                :search-input="accountQuery"
                @update:search-input="searchAccount"
                :items="ledgerAccounts"
                item-value="id"
                item-text="display_name"
                outlined
                dense
                single-line
                hide-details="auto"
            >
            </v-autocomplete>
        </v-col>
        <v-col cols="2" class="pe-1">
            <v-text-field
                label="Amount"
                v-model="line.document_amount"
                :suffix="currency ? currency.code : null"
                :rules="[isRequired, isNumeric]"
                dense
                :disabled="!line.ledger_account_id"
                outlined
                hide-details="auto"
            >
            </v-text-field>
        </v-col>
        <v-col cols="2" v-if="isForeign" class="pe-1">
            <v-text-field
                label="Base Amount"
                :suffix="baseCurrency ? baseCurrency.code : null"
                disabled
                background-color="disabled"
                :value="baseAmount"
                dense
                outlined
                hide-details="auto"
            >
            </v-text-field>
        </v-col>
        <v-col cols="2" class="pe-1">
            <v-text-field
                label="Ledger Amount"
                :suffix="accountCurrency ? accountCurrency.code : null"
                disabled
                :value="accountAmount"
                background-color="disabled"
                dense
                outlined
                hide-details="auto"
            >
            </v-text-field>
        </v-col>
        <v-col cols="2" class="pe-1">
            <v-autocomplete
                label="Dimension"
                v-model="line.dimension_id"
                outlined
                :items="dimensions"
                item-text="name"
                item-value="id"
                @update:search-input="searchDimensionsAsync"
                :loading="dimensionsLoading"
                dense
                hide-details="auto">
            </v-autocomplete>
        </v-col>
        <v-col cols="4" class="pe-1 d-flex align-center">
            <v-text-field
                v-model="line.description"
                label="Description"
                dense
                outlined
                hide-details="auto"
            >
            </v-text-field>
            <v-btn icon class="mr-2" @click="handleDeleteLine">
                <v-icon>mdi-close</v-icon>
            </v-btn>
        </v-col>
    </v-row>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { isRequired, isNumeric } from "./../../utils/validations";
import dimensionAPI from './../../services/purchase/dimension';

export default {
    name: "CreditNoteFormLine",
    props: {
        value: Object,
        currency: Object,
        baseCurrency: Object,
        exchangeRates: Array,
        showAccountAmount: Boolean,
    },
    data() {
        return {
            line: { ...this.value },
            accountQuery: "",
            dimensions: [],
            dimensionsLoading: false
        }
    },
    computed: {
        ...mapGetters({
            ledgerAccounts: "purchase/ledgerAccount/list",
            loading: "purchase/ledgerAccount/loading"
        }),
        exchangeRate() {
            if(!this.currency) return null;
            return this.exchangeRates.find(exchangeRate => exchangeRate.currency_id == this.currency.id);
        },
        baseAmount() {
            if(!this.exchangeRate) return 0;
            return this.line.document_amount * this.exchangeRate.customRate;
        },
        isForeign() {
            if(!this.currency) return false;
            return this.baseCurrency.id != this.currency.id;
        },
        account() {
            return this.ledgerAccounts.find(account => account.id  == this.line.ledger_account_id)
        },
        accountCurrency() {
            if(!this.account) return null;
            return this.account.currency
        },
        accountCurrencyExchangeRate() {
            if(!this.accountCurrency) return null;
            return this.exchangeRates.find(exchangeRate => exchangeRate.currency_id == this.accountCurrency.id);
        },
        accountAmount() {
            if(!this.accountCurrencyExchangeRate) return 0;
            return this.baseAmount / this.accountCurrencyExchangeRate.customRate;
        },
        
    },
    watch: {
        line : {
            handler(line) {
                this.$emit("input", {...line});
            },
            deep : true
        },
        accountAmount(amount) {
            this.line.amount = amount;
        },
        baseAmount(amount) {
            this.line.base_amount = amount;
        },
        currency() {
            this.$emit("input", {...this.line, amount: this.accountAmount, base_amount: this.baseAmount});
        }
    },
    methods: {
        ...mapActions({
            searchAccount: "purchase/ledgerAccount/search"
        }),
        isRequired,
        isNumeric,
        handleDeleteLine() {
            this.$emit("deleteLine")
        },
        searchDimensionsAsync(query) {
            this.dimensionsLoading = true;
            dimensionAPI.search(query).then(response => {
                this.dimensions = Array.from(new Set([...this.dimensions, ...response.data]));
            }).finally(() => {
                this.dimensionsLoading = false;
            })
        }
    },
    created() {
        if(this.value) {
            if(this.value.dimension) {
                this.dimensions.push(this.value.dimension);
            }
        }
    }
}
</script>

<style>

</style>